import { Controller, useFormContext } from "react-hook-form";
import { TextField } from "@mui/material";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
InputPassword.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
};
// @ts-ignore
export default function InputPassword({ name, label, disabled }) {
    const {
        control,
        formState: { isSubmitting },
    } = useFormContext();
    const [showPassword, setShowPassword] = useState(false);
    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
                <TextField
                data-testid={`${name}-input`}
                    sx={
                        !showPassword
                            ? {
                                  "& input": {
                                      textSecurity: "disc",
                                      "MozTextSecurity": "disc",
                                      "WebkitTextSecurity": "disc",
                                  },
                              }
                            : {}
                    }
                    autoComplete={"off"}
                    InputProps={{
                        autoComplete: "off", // disable autocomplete and autofill
                        endAdornment: (
                            <InputAdornment position={"start"}>
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() => {
                                        setShowPassword(!showPassword);
                                    }}
                                    edge="end"
                                >
                                    {showPassword ? (
                                        <Visibility />
                                    ) : (
                                        <VisibilityOff />
                                    )}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    label={label}
                    fullWidth
                    size={"small"}
                    onChange={(event) => {
                        onChange(event);
                    }}
                    error={!!error}
                    disabled={isSubmitting || disabled}
                    value={value}
                    helperText={error?.message}
                    margin={"dense"}
                />
            )}
        />
    );
}
